import { render } from "./UpdateUserPassword.vue?vue&type=template&id=5387dea8"
import script from "./UpdateUserPassword.vue?vue&type=script&lang=js"
export * from "./UpdateUserPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__